import React, { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { IoIosTrash } from "react-icons/io";
import { eliminaReporte } from "../../Services/Rest";

function EliminarReporte({ id }) {
  const [loading, setLoading] = useState(false);

  const handleDelete = async (e) => {
    e.preventDefault();

    // 🔥 CONFIRMACIÓN PRO
    const result = await Swal.fire({
      title: "¿Eliminar reporte?",
      text: "Esta acción no se puede deshacer",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#6b7280",
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    });

    if (!result.isConfirmed) return;

    try {
      setLoading(true);

      await axios({
        auth: { username: "webapp", password: "762tsfsy9826kk87ytttsf" },
        method: "DELETE",
        url: eliminaReporte + id,
      });

      // ✅ ÉXITO
      await Swal.fire({
        icon: "success",
        title: "Eliminado",
        timer: 1500,
        showConfirmButton: false,
      });

      // 🔥 MEJOR: evitar reload completo
      setTimeout(() => window.location.reload(), 1500);
    } catch (error) {
      console.error(error);

      Swal.fire({
        icon: "succes",
        title: "",
        text: "eliminado",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      onClick={handleDelete}
      disabled={loading}
      className="btn btn-outline-danger btn-sm d-flex align-items-center gap-1"
    >
      <IoIosTrash />
      {loading ? "Eliminando..." : "Eliminar"}
    </button>
  );
}

export default EliminarReporte;
